import React from 'react';
import { IndustryTechStackItem } from '../../data/industryData';
import '../../styles/TechStackSection.css';

interface TechStackSectionProps {
  title: string;
  description: string;
  items: IndustryTechStackItem[];
}

// Title component with unique styling
const SectionTitle = ({ title }: { title: string }) => {
  // Split the title to highlight key words
  const words = title.split(' ');
  const highlightIndex = words.findIndex(word => word.toLowerCase() === 'with') || Math.floor(words.length / 2); // Highlight "with" or middle word
  
  return (
    <div className="title-container">
      <h2 className="tech-stack-title">
        {words.map((word, index) => 
          index === highlightIndex ? 
            <span key={index} className="title-highlight">{word} </span> : 
            <span key={index}>{word} </span>
        )}
      </h2>
      <span className="title-accent">
        <span className="dot"></span>
        <span className="dot"></span>
        <span className="dot"></span>
      </span>
    </div>
  );
};

const TechStackSection: React.FC<TechStackSectionProps> = ({ title, description, items }) => {
  return (
    <section className="tech-stack-section">
      <div className="glass-overlay"></div>
      <div className="tech-stack-container">
        <div className="tech-stack-two-column">
          <div className="tech-stack-image-container">
            <img 
              src="/assets/techstacksection.svg" 
              alt="Technology stack visualization" 
              className="tech-stack-image"
            />
          </div>
          <div className="tech-stack-content">
            <div className="tech-stack-header">
              <SectionTitle title={title} />
              <p className="tech-stack-description">{description}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TechStackSection;